import bookingReservationService from "@services/booking/bookingReservationService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"

class BookingReservationStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable overViewData!: any
  @observable latestRequest!: any
  @observable isRequestLoading!: boolean

  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.overViewData = {}
    this.latestRequest = null
    this.isRequestLoading = false
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await bookingReservationService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async newBooking() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await bookingReservationService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await bookingReservationService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  /**
   * Lookup reservation cua 1 booking (khong mutate tableData/isLoading cua store).
   * Dung cho cac man list theo booking can thao tac "yeu cau" (vd: cart detail > tab Dat cho).
   */
  async getReservationByBooking(bookingId: number): Promise<any> {
    if (!bookingId) return null
    const result = await bookingReservationService.getAll({
      bookingId,
      maxResultCount: 1,
      skipCount: 0,
    })
    return result?.items?.[0] ?? null
  }

  @action
  async getOverview(params: any) {
    const result = await bookingReservationService.getOverview(params)

    this.overViewData = result
  }
  @action
  async updateStatus(body: any) {
    this.isLoading = true
    await bookingReservationService
      .updateStatus(body)
      .finally(() => (this.isLoading = false))
  }

  @action
  clearLatestRequest() {
    this.latestRequest = null
  }

  @action
  async submitRequest(body: any): Promise<any> {
    this.isRequestLoading = true
    const result = await bookingReservationService
      .submitRequest(body)
      .finally(() => (this.isRequestLoading = false))
    return result
  }

  @action
  async getLatestRequest(bookingReservationId: number): Promise<void> {
    this.isRequestLoading = true
    const result = await bookingReservationService
      .getLatestRequest(bookingReservationId)
      .finally(() => (this.isRequestLoading = false))
    this.latestRequest = result
  }

  @action
  async processRefundBooking(body: {
    bookingReservationRequestId: number
    processDate: string
  }): Promise<void> {
    this.isRequestLoading = true
    await bookingReservationService
      .processRefundBooking(body)
      .finally(() => (this.isRequestLoading = false))
  }

  @action
  async processOffsetBooking(body: {
    bookingReservationRequestId: number
    processDate: string
  }): Promise<void> {
    this.isRequestLoading = true
    await bookingReservationService
      .processOffsetBooking(body)
      .finally(() => (this.isRequestLoading = false))
  }
}

export default BookingReservationStore
